import React from "react";
import PropTypes from 'prop-types';
import Autocomplete from '@mui/lab/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { withStyles } from "@mui/styles";
import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

class AdminProfiiliAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            Username: null,
            Kieli: null,
            FullName: null,
            Email: null,
        };
    }

    handleSave = () => {
        this.props.onAddNewRow({
            ProfiiliId: 1, //dummay-arvo
            Username: this.state.Username,
            AsiakasAvain: 1,
            OletusNakyma: "M",
            Kieli: this.state.Kieli,
            FullName: this.state.FullName,
            Email: this.state.Email,
            AccountType: "External"
        });
        this.setState({ open: false });
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    render() {
        const { dictionary } = this.context;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.AdminProfiili.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required={true}
                            margin="dense"
                            id="Username"
                            label={dictionary.AdminProfiili.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Username || ""}
                            onChange={this.handleChange('Username')}
                        />
                        <FormControl fullWidth>
                            <InputLabel id="select-label-kieli">{dictionary.AdminProfiili.Columns[4]}</InputLabel>
                            <Select
                                labelId="select-label-kieli"
                                value={this.state.Kieli || ""}
                                label={dictionary.AdminProfiili.Columns[4]}
                                onChange={this.handleChange('Kieli')}
                            >
                                <MenuItem value="fi">fi</MenuItem>
                                <MenuItem value="en">en</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            margin="dense"
                            id="FullName"
                            label={dictionary.AdminProfiili.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.FullName || ""}
                            onChange={this.handleChange('FullName')}
                        />
                        <TextField
                            margin="dense"
                            id="Email"
                            label={dictionary.AdminProfiili.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Email || ""}
                            onChange={this.handleChange('Email')}
                        />
                        
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" onClick={this.handleClose}>
                            {dictionary.Close}
                        </Button>
                        <Button variant="contained" color="primary" style={{ color: "#fff" }} onClick={this.handleSave}>
                            {dictionary.Save}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminProfiiliAdd" })(AdminProfiiliAdd);
